import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useNavigate } from '@tanstack/react-router';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Not Found</CardTitle>
          <CardDescription>
            Sorry, we couldn't find the page you're looking for
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="flex flex-row gap-2 justify-center">
            <Button onClick={() => navigate({ to: '/' })} variant="default">
              Home
            </Button>
            <Button onClick={() => navigate({ to: '..' })} variant="outline">
              Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
